/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M5 12.5c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1H5ZM4 18c0-.5523.4477-1 1-1h7.5c.5523 0 1 .4477 1 1s-.4477 1-1 1H5c-.5523 0-1-.4477-1-1ZM14.5 10c.8284 0 1.5-.6716 1.5-1.5S15.3284 7 14.5 7 13 7.6716 13 8.5s.6716 1.5 1.5 1.5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 4c0-2.2091 1.7909-4 4-4h12c2.2091 0 4 1.7909 4 4v.8624C22.4208 6.458 24 8.5 24 8.5s-1.5792 2.042-4 3.6376v4.8739a3.9997 3.9997 0 0 1-1.4393 3.0729l-3.5861 2.9885A4.0003 4.0003 0 0 1 12.4139 24H4c-2.2091 0-4-1.7909-4-4V4Zm16-2c1.0254 0 1.8706.7717 1.9865 1.766C16.907 3.3028 15.7309 3 14.5 3 9.2533 3 5 8.5 5 8.5S9.2533 14 14.5 14c1.236 0 2.4169-.3052 3.5-.7719v3.7834a2 2 0 0 1-.7196 1.5365l-3.5862 2.9884A1.9995 1.9995 0 0 1 12.4139 22H4c-1.1046 0-2-.8954-2-2V4c0-1.1046.8954-2 2-2h12ZM7.6994 8.5a17.0788 17.0788 0 0 1 1.3323-1.1881C10.6162 6.0446 12.549 5 14.5 5c1.9509 0 3.8838 1.0446 5.4683 2.3119.5126.41.9618.8217 1.3323 1.1881a17.0748 17.0748 0 0 1-1.3323 1.1881C18.3838 10.9554 16.4509 12 14.5 12c-1.9509 0-3.8838-1.0446-5.4683-2.3119A17.0768 17.0768 0 0 1 7.6994 8.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'ObserveDocument'
);
